export default {
  baseStyle: {
    excessLabel: {
      fontSize: "xs",
    },
  },
};
